module.exports = __webpack_public_path__ + "img/5d01aa7.png";